export function obj2array(obj, addkey){
    
    if ( typeof(addkey) == "undefined") { addkey = false;  }

    
    var a =[];
    
    
    if($.isArray(obj)){
        return obj;
    }
    else if(obj!==undefined && obj!==null){
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
               if(addkey){
                   obj[key]['key'] = key
               }
               a.push(obj[key]);
            }
        }
    }
    
    return a;
}

// say a = {x:{y:{z:1}}}
// call it with getNested(a, 'x', 'y', 'z');
export function getNested(obj /*, level1, level2, ... levelN*/) {
  var args = Array.prototype.slice.call(arguments, 1);

  for (var i = 0; i < args.length; i++) {
    if (!obj || !obj.hasOwnProperty(args[i])) {
      return undefined;
    }
    obj = obj[args[i]];
  }
  return obj;
}


export function isLocalStorageSupported(){
    if (typeof(Storage) !== "undefined") {

        // for ios safari, private mode, we need to actually try it.
        var testKey = 'test';
        try
        {
            localStorage.setItem(testKey, '1');
            localStorage.removeItem(testKey);
            return true;
        }
        catch (error)
        {
            return false;
        }
    }
    else{
        return false;
    }

} 



export function breakCamelCase(s){
    return s.replace(/([A-Z])/g, ' $1')                                 // insert a space before all caps
            .replace(/^./, function (str){return str.toUpperCase();});  // uppercase the first character
}


export function breakSnakeCase(s){
    return s.replace(/(_)/g, ' ')                                 // insert a space before all caps
            .replace(/^./, function (str){return str.toUpperCase();});  // uppercase the first character
}


export function arrayInterSection(a, b){
    return a.filter(function(n) {
        return b.indexOf(n) !== -1;
    })
} 


export function arrayUnion(a, b){
    var res = a.slice();
    for(var i=0; i<b.length; i++){
        var t = b[i];
        if(res.indexOf(t)==-1){
            res.push(t);
        }
    }
    return res;
} 


//header: {label:'ID', db_field:'primaryKeyId' }
export function tableHeaderClicked(header, reactComponent,  state_variable, callback ){
    
    if(typeof header != 'object'){
        console.error('wrong header specified for tableHeaderClicked()');
        return;
    }
    
    if(typeof state_variable == 'undefined'){
        state_variable = 'orderBy';
    }
    
    
    
    
    if(header.db_field!=undefined ){            
        var currentField = header.db_field
        var orderBy = {field:currentField, asc:false};

        if(reactComponent.state[state_variable].field == currentField){
            orderBy.asc = !reactComponent.state[state_variable].asc                
        }

        var state = {};
        state[state_variable] = orderBy;
        
        if(typeof callback == 'function'){
            
            reactComponent.setState(state, callback);
        }
        else{
            reactComponent.setState(state);
        }
        
    }

}


// export {obj2array};


export function humanFileSize(size) {
    if (size < 1) {
        return '0 B';
    }
    const i = Math.floor(Math.log(size) / Math.log(1024));
    const fixed = (size / Math.pow(1024, i)).toFixed(2);
    return fixed + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i];
};

export function template(str, tokens) {
    return str.replace(/%([^%]+)%/g, (_, token) => tokens[token]);
}

export const isNull = (value) => {
    if (
        typeof value !== 'undefined'
        && value !== undefined
        && value != null
        && value != NaN
        && value
    ) {
        return false;
    }

    return true;
}

export function arrayLikeToArray(o) {
    const a = [];
    Object.keys(o).forEach(k => {
        a[k] = o[k];
    });
    return a;
}


// date1_str, date2_str should be in formate 'YYYY-mm-dd'
// return:  [ [month, year], [month, year], ... ], where month: 0-11
export function getMonthsBetween(date1_str, date2_str) {
    let date1 = new Date(date1_str);
    let date2 = new Date(date2_str);
    
    if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
        return [];
    }

    // Ensure date1 is earlier than date2
    if (date1 > date2) {
        [date1, date2] = [date2, date1];
    }

    /*
    const months = [];
    let currentDate = new Date(date1);
    currentDate.setDate(1); // Set to the first day of the month
    while (currentDate <= date2) {
        months.push([currentDate.getUTCMonth(), currentDate.getUTCFullYear()]);
        currentDate.setMonth(currentDate.getMonth() + 1);
    }
    */

    let months = [];
    let [y1, m1, d1] = date1_str.split('-');
    let [y2, m2, d2] = date2_str.split('-');

    while (y1 < y2 || (y1 == y2 && m1 <= m2)) {
        months.push([parseInt(m1)-1, parseInt(y1)]);
        m1++;
        if (m1 > 12) {
            m1 = 1;
            y1++;
        }
    }


    return months;
}
